import { defineStore } from "pinia";
import { ref } from "vue";
import { Login ,getNicknameLogin} from "@/api/login";
import MENU from "@/data/menu";
import {
  selectMyInfo,
  getByUserId,
  openIdLogin,
  getByAdmin,
  evidenceUserInit,
} from "../api";
import { _ROLE } from "../data/enum";
import type { getUserInfoType, setUserInfoType } from "login.type.ts";

export const useLoginStore = defineStore("login", {
  state: () => {
    return {
      isLogin: ref(false), // 是否登录
      userInfo: ref({}), // 用户信息
      auth: "", // 角色
      authName: "",
      navBarList: [], //不同角色不同菜单
      token: "",
    };
  },

  actions: {
    getUserInfo() {
      return this.userInfo;
    },

    setUserInfo(userInfo) {
      this.isLogin = true;
      this.userInfo = userInfo;
      this.auth = userInfo.roleid;
      this.token = userInfo.token;
      this.authName = _ROLE[userInfo.roleid] || "-";
      // console.log(_ROLE, userInfo.roleid, this.authName);
      uni.setStorageSync("userInfo", userInfo);
    },

    setMenu(userInfo) {
      this.navBarList = MENU[4];
      console.log(this.navBarList);
    },

    updateUserInfo(key, value) {
      console.log(key, value);
      this.userInfo[key] = value;
      uni.setStorageSync("userInfo", this.userInfo);
    },

    resetUserInfo() {
      this.isLogin = false;
      this.userInfo = {};
    },

    async Login(params) {
      const res = await Login(params);

      console.log(res);
      if (res.code == 0) {
        res.data.adminLoginVO.roleid = res.data.adminLoginVO.roleid
          ? res.data.adminLoginVO.roleid
          : 2;
        this.setUserInfo(res.data.adminLoginVO);
        this.setMenu(res.data.adminLoginVO);

        return true;
      } else {
        uni.showToast({
          icon: "none",
          title: res.msg ? res.msg : "登录失败，请稍候再试",
        });
        return false;
      }
    },
    async SingleLogin(params) {
      const res = await getNicknameLogin(params);

      if (res.code == 0) {
        res.data.adminLoginVO.roleid = res.data.adminLoginVO.roleid
            ? res.data.adminLoginVO.roleid
            : 2;
        this.setUserInfo(res.data.adminLoginVO);
        this.setMenu(res.data.adminLoginVO);

        return true;
      } else {
        uni.showToast({
          icon: "none",
          title: res.msg ? res.msg : "跳转登录失败，请稍候再试",
        });
        return false;
      }
    },
    async watchLogin(params) {
      const res = await openIdLogin(params);

      console.log(res);
      if (res.code == 0) {
        res.data.adminLoginVO.roleid = res.data.adminLoginVO.roleid
          ? res.data.adminLoginVO.roleid
          : 2;
        this.setUserInfo(res.data.adminLoginVO);
        this.setMenu(res.data.adminLoginVO);

        return true;
      } else if (res.code == 1005) {
        uni.showToast({
          icon: "none",
          title: "该微信暂未绑定账号，请注册登录后绑定微信",
        });
        return false;
      } else {
        uni.showToast({ icon: "none", title: res.msg });
        return false;
      }
    },

    logout() {
      uni.removeStorageSync("userInfo");
      this.resetUserInfo();
    },
    tabbarSwitch(e) {
      console.log(e);
      uni.switchTab({
        url: e.pagePath,
      });
    },
    getCurrentTabbarIndex(path) {
      let index = 0;
      this.navBarList.some((item, i) => {
        if (item.pagePath == path) {
          index = i;
          return true;
        }
      });
      console.log(index);
      return index;
    },
  },
});
